import type { ContactResponse, ConversationResponse } from '@blazeteams/sdk';
import { transformConversationCache } from './conversation-cache';

/** Fields embedded by the API in `ConversationResponse.contact`. */
const CONTACT_SUMMARY_FIELDS = [
  'avatar',
  'display_name',
  'id',
  'name_locked',
  'phone',
  'provider_type',
  'tags',
] as const;

export function contactSummaryPatch(patch: Partial<ContactResponse>) {
  const summary: Partial<NonNullable<ConversationResponse['contact']>> = {};
  for (const field of CONTACT_SUMMARY_FIELDS) {
    if (Object.prototype.hasOwnProperty.call(patch, field)) {
      Object.assign(summary, { [field]: patch[field] });
    }
  }
  return summary;
}

/**
 * Apply a contact delta to the contact summary embedded in every flat/infinite
 * Inbox list cache. This keeps context-menu state and contact tag filters in
 * sync while the server refetch reconciles the canonical row.
 */
export function patchConversationContactCache(
  cache: unknown,
  contactId: string,
  patch: Partial<ContactResponse>,
): unknown {
  const summary = contactSummaryPatch(patch);
  return transformConversationCache(cache, (conversations) =>
    conversations.map((conversation) => {
      const embeddedId = conversation.contact?.id ?? conversation.contact_id;
      if (embeddedId !== contactId) return conversation;
      return {
        ...conversation,
        contact: {
          ...conversation.contact,
          id: conversation.contact?.id ?? contactId,
          ...summary,
        },
      };
    }),
  );
}
